<div class="page-head-section">
  <p>Rules & Guidelines</p>
</div>

<div class="rules-content">
  <p class="subhead">Rules & Guidelines of Archery association of India:</p>

  <div *ngFor="let data of rules;let i=index;" class="rules-row" (click)="toLink(data)">
  {{i+1}}.  {{data.title}}
  <!-- <span>
      <img src="assets/icons/right.svg" alt="">
  </span> -->
  </div>

</div>



<!-- <div class="card">
    <h5>Implicit Pagination</h5>
    <p-table [value]="rules" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" 
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,25,50]">
        <ng-template pTemplate="header">
            <tr>
                <th>Name</th>
                <th>Country</th>
                <th>Company</th>
                <th>Representative</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rule>
            <tr>
                <td>{{rule.name}}</td>
                <td>{{rule.link}}</td>
                <td>dsfsdf</td>
                <td>sdfsdfsd</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
            <p-button type="button" icon="pi pi-plus" styleClass="p-button-text"></p-button>
        </ng-template>
        <ng-template pTemplate="paginatorright">
            <p-button type="button" icon="pi pi-cloud" styleClass="p-button-text"></p-button>
        </ng-template>
    </p-table>
</div> -->